import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/AppButton/AppButton';
import { AuthServiceContext } from '../../../../services/AuthService';
//import LoadingMarkUp from '../../../../components/Loading/Loading';

const LogOut = () => {
  const { logout } = useContext(AuthServiceContext);
  const { t } = useTranslation();
  // //const lang = i18n.language || 'en';

  const handleClick = async () => {
    await logout();
  };

  return (
    <div>
      <AppButton label={'logout'} leftIcon transparent large type="button" onClick={handleClick}>
        <LogoutIcon />
      </AppButton>
    </div>
  );
};

export default LogOut;

const LogoutIcon = () => {
  return (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8306 3.51929C19.0919 3.51929 21.7453 6.17262 21.7453 9.43395V10.6766C21.7453 11.2286 21.2973 11.6766 20.7453 11.6766C20.1933 11.6766 19.7453 11.2286 19.7453 10.6766V9.43395C19.7453 7.27395 17.9893 5.51929 15.8306 5.51929H9.33059C7.17459 5.51929 5.41992 7.27395 5.41992 9.43395V24.2726C5.41992 26.4313 7.17459 28.186 9.33059 28.186H15.8453C17.9946 28.186 19.7453 26.4366 19.7453 24.2873V23.03C19.7453 22.478 20.1933 22.03 20.7453 22.03C21.2973 22.03 21.7453 22.478 21.7453 23.03V24.2873C21.7453 27.5406 19.0973 30.186 15.8453 30.186H9.33059C6.07192 30.186 3.41992 27.534 3.41992 24.2726V9.43395C3.41992 6.17262 6.07192 3.51929 9.33059 3.51929H15.8306ZM26.6041 12.258L30.5081 16.1446C30.5429 16.1792 30.5741 16.2151 30.6026 16.2531L30.5081 16.1446C30.5553 16.1912 30.5973 16.2421 30.6338 16.2964C30.6498 16.3209 30.6653 16.3464 30.6796 16.3725C30.6913 16.3929 30.702 16.4142 30.7119 16.4359C30.7203 16.455 30.7284 16.4742 30.7359 16.4936C30.7459 16.519 30.7547 16.545 30.7625 16.5714C30.7683 16.5922 30.7736 16.613 30.7783 16.634C30.7843 16.6594 30.789 16.685 30.7926 16.7109C30.7947 16.7276 30.7968 16.7452 30.7984 16.763C30.8014 16.7934 30.8027 16.8229 30.8027 16.8526L30.7959 16.9353L30.7932 16.9883C30.7929 16.9905 30.7926 16.9928 30.7922 16.995L30.8027 16.8526C30.8027 16.9266 30.7945 16.9999 30.7786 17.0712C30.7736 17.0923 30.7683 17.113 30.7623 17.1335C30.7547 17.1602 30.7459 17.1863 30.7361 17.2119C30.7284 17.231 30.7203 17.2502 30.7117 17.269C30.702 17.291 30.6913 17.3123 30.6798 17.3332C30.6653 17.3589 30.6498 17.3843 30.6333 17.4089C30.6239 17.4236 30.6136 17.438 30.603 17.4522C30.5712 17.4939 30.5366 17.5332 30.4992 17.5696L26.6041 21.4486C26.4094 21.6433 26.1534 21.7406 25.8987 21.7406C25.6427 21.7406 25.3854 21.6433 25.1907 21.446C24.8014 21.054 24.8027 20.422 25.1934 20.0326L27.3799 17.8526H13.7477C13.1957 17.8526 12.7477 17.4046 12.7477 16.8526C12.7477 16.3006 13.1957 15.8526 13.7477 15.8526H27.3826L25.1934 13.674C24.8027 13.2846 24.8001 12.6526 25.1907 12.2606C25.5801 11.8686 26.2121 11.8686 26.6041 12.258Z"
        fill="white"
      />
    </svg>
  );
};
